import { render } from "./Queries.vue?vue&type=template&id=e65ae734&ts=true"
import script from "./Queries.vue?vue&type=script&lang=ts"
export * from "./Queries.vue?vue&type=script&lang=ts"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__